<template>
  <standard-dialog
    v-model="model"
    :title="$t('create_new_limit')"
    max-width="500"
    @save="handleSave"
    :loading="saving"
  >
    <v-form ref="form">
      <text-field
        v-model="limitName"
        :label="$t('limit_name')"
        :rules="[(v) => !!v || $t('required_field')]"
        outlined
        required
      />
    </v-form>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import limitService from "@/services/limit";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  name: "CreateLimitDialog",
  components: {
    StandardDialog,
  },
  mixins: [hasModel, hasSnackbar],
  props: {
    companyId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      limitName: "",
      saving: false,
    };
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.limitName = "";
        this.$nextTick(() => {
          this.$refs.form?.resetValidation();
        });
      }
    },
  },
  methods: {
    async handleSave() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      try {
        const payload = {
          name: this.limitName,
          scope: "company",
          company_id: parseInt(this.companyId),
        };
        const { data } = await limitService.createLimit(payload);
        this.showSuccessSnackbar(this.$t("limit_created_successfully"));
        this.$emit("created", data.data);
        this.model = false;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_creating_limit"));
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
